/**
 * Initializes the click behavior for an interactive features list.
 * On click, adds an 'active' class to the item. Clicking again removes it.
 * Only one item can be active at a time.
 * @param {HTMLElement} listContainer - The container with [data-lazy-init="features-list"].
 */
export function initFeaturesListIndexPage(listContainer) {
	const featuresList = listContainer.querySelectorAll('.features__list-item.__hover-content');
	if (!featuresList.length) return;

	// console.log('Lazy initializing features list...', listContainer);

	function setActive(item, active) {
		item.classList.toggle('active', active);
		item.setAttribute('aria-expanded', String(active));
	}

	featuresList.forEach((item) => {
		item.addEventListener('click', () => {
			const wasActive = item.classList.contains('active');
			featuresList.forEach(i => setActive(i, false));
			if (!wasActive) {
				setActive(item, true);
			}
		});

		item.addEventListener('keydown', (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				const wasActive = item.classList.contains('active');
				featuresList.forEach(i => setActive(i, false));
				if (!wasActive) {
					setActive(item, true);
				}
			}
			if (e.key === 'Escape') {
				setActive(item, false);
				item.focus();
			}
		});
	});
}